import {Component, OnDestroy, OnInit} from '@angular/core';
import {SubscriberMelody} from "../../model/subscriber-melody";
import {SubscriberService} from "../../services/subscriber.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-subscriber-melodies-page',
  templateUrl: './subscriber-melodies-page.component.html',
  styleUrls: ['./subscriber-melodies-page.component.css'],
  host: {
    class: 'app-page'
  }
})
export class SubscriberMelodiesPageComponent implements OnInit, OnDestroy {
  melodies: ReadonlyArray<SubscriberMelody>
  filteredMelodies: Array<SubscriberMelody>;
  filter: Filter;

  standardMelodyPlaying: boolean;

  subscription: Subscription;
  isLoading: boolean = true;

  constructor(private readonly subscriberService: SubscriberService) {
    this.melodies = [];
    this.filteredMelodies = [];
    this.filter = Filter.PLAYING_FOR_ALL;
    this.standardMelodyPlaying = false;

    this.subscription = new Subscription();
  }

  updateFilter(filter: Filter): void {
    this.filter = filter;
    this.filterMelodies();
  }

  filterMelodies(): void {
    this.filteredMelodies = this.melodies.filter(melody => {
      if (this.filter == Filter.PLAYING_FOR_ALL) {
        return melody.playingForAll;
      } else if (this.filter == Filter.WITH_RULES) {
        return melody.usedInRules;
      } else if (this.filter == Filter.NOT_PLAYING) {
        return !melody.playingForAll && !melody.usedInRules;
      }
      return false;
    });

    this.standardMelodyPlaying = this.filteredMelodies.length == 1 && this.filteredMelodies[0].idFromPlatform == -1; //Only standard melody is active
  }

  ngOnInit(): void {
    this.isLoading = true;

    this.subscriberService.loadSubscriberMelodies().subscribe({
      next: (melodies) => {
        this.melodies = melodies;
        this.filterMelodies();
        this.isLoading = false;
      },
      error: (error) => {
        console.error(error);
        this.isLoading = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  protected readonly Filter = Filter;
}

enum Filter {
  PLAYING_FOR_ALL,
  WITH_RULES,
  NOT_PLAYING
}
